import React, { AllHTMLAttributes, useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import photoSvg from "@/assets/icon-svg/account/photo.svg";
import authSvg from "@/assets/icon-svg/account/auth.svg";
import timeSvg from "@/assets/icon-svg/account/time.svg";
import unpassSvg from "@/assets/icon-svg/account/unpass.svg";
import XtSvg from "@/components/Xt/Svg";
import { Tooltip, Modal } from "antd";
import { useRouter } from "next/router";
import { waitRes } from "@/utils/axios";
// import { get_kycLimit } from "@/api/exchange-otc"; // kyc-limit 接口已注释
import { get_kycWalletLimit } from "@/api/xt4/wallet";
import { get_enterpriseApplyReason } from "@/api/xt-user";
export interface LimitProps {
  createdTime?: number;
  grade: number;
  id: number;
  limitAmount: number;
  updatedTime?: number;
}
export interface WithdrawLimitProps extends LimitProps {
  tenantId?: number;
}
interface EnterpriseNameProps {
  enterpriseName: string | null;
  reason: string | null;
  status: number;
}
interface CompanyProps extends AllHTMLAttributes<HTMLElement> {
  attr?: any;
}
const { useTranslation } = Hooks;
const Company: React.FC<CompanyProps> = ({ className }) => {
  const t = useTranslation();
  const router = useRouter();
  const containerRef = useRef<HTMLDivElement>(null);
  //const {isLogin} = store.user;
  const [limitList, setLimitList] = useState<LimitProps[]>([]);
  const [withdrawLimitList, setWithdrawLimitList] = useState<WithdrawLimitProps[]>([]);
  const [confirmResult, setConfirmResult] = useState({} as EnterpriseNameProps);
  const [showmodal, setShowmodal] = useState(false);

  /** useEffect */
  useEffect(() => {
    store.user.getAuthInfo();
    window.addEventListener("click", otherClose);
    getKycWithdrawLimit();
    // enterpriseApplyReason();
    return () => {
      window.removeEventListener("click", otherClose);
    };
  }, []);

  /** method */
  const otherClose = (e: Event) => {
    if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
      setShowmodal(false);
    }
  };

  const getKycWithdrawLimit = async () => {
    const defaultResWallet = [
      { grade: 0, limitAmount: 1000000, id: 1 },
      { grade: 1, limitAmount: 1000000, id: 2 },
      { grade: 2, limitAmount: 1000000, id: 3 },
      { grade: 3, limitAmount: 1000000, id: 4 },
    ];
    // 法币 - kyc-limit 接口已注释，使用默认限额
    // const { data, err } = await waitRes(get_kycLimit, { isResFull: true });
    // !err && setLimitList(data && data.length != 0 ? [...data] : defaultResWallet);
    setLimitList(defaultResWallet);

    // 提现
    const { data: resWallet, err: errWallet } = await waitRes(get_kycWalletLimit, {});
    !errWallet && setWithdrawLimitList(resWallet && resWallet.length != 0 ? resWallet : defaultResWallet);
  };

  const enterpriseApplyReason = async () => {
    const { data: res, err } = await waitRes(get_enterpriseApplyReason);
    if (err) return;
    setConfirmResult(res || {});

  };

  const getVerifyState = (status = -1) => {
    const map = {
      [-1]: "未申请",
      0: "审查中",
      1: "通过",
      2: "未通过",
    };
    return map[status];
  };

  const jumpconfirm = () => {
    store.user.updateState({ canEnterprise: true });

    router.push({ pathname: "/accounts/user/institutions", search: `verify_state=${confirmResult.status == 2 ? "未通过" : "未申请"}` });
  };
  return (
    <>
      {limitList && !!limitList.length && (
        <div className={cx(styles["v-auth-guide"], className)}>
          <div className={cx(styles["ll-auth-guide-div"])}>
            <div className={cx(styles["flex_top"])}>
              <div>
                <div className={cx(styles["p_lever"])} style={{ display: "inline-block" }}>
                  <span className={cx(styles["lever_name"])} style={{ color: confirmResult.status == -1 ? "rgba(238, 86, 87, 1)" : "" }}>
                    {confirmResult.status == 1 ? confirmResult.enterpriseName : t("account.unverified")}
                  </span>
                </div>
              </div>
              <div className={cx(styles["view_btn"])} ref={containerRef}>
                <span onClick={() => setShowmodal(!showmodal)}>{t("account.CurrentAmountLimit")}</span>
              </div>
            </div>
          </div>
          <div className={styles["confirm_content"]}>
            <div className={styles["confirm_list"]}>
              <div className={styles["list_content"]}>
                <div className={styles["list_c_header"]}>
                  <span style={{ fontWeight: "bold" }}>{t("account.companyConfirm")}</span>
                  <div>
                    {confirmResult.status == 1 && <span className={styles["is_confirm"]}>{t("account.verified")}</span>}
                    {confirmResult.status == 0 && (
                      <span className={styles["is_confirm"]} style={{ color: "rgba(56, 55, 66, 1)", backgroundColor: "rgba(243, 245, 247, 1)" }}>
                        {t("account.UnderReview")}
                      </span>
                    )}
                    {confirmResult.status == 2 && (
                      <span className={styles["is_confirm"]} style={{ color: "rgba(238, 86, 87, 1)", backgroundColor: "rgba(238, 86, 87, 0.1)" }}>
                        {t("account.Failed")}
                      </span>
                    )}
                  </div>
                </div>
                <div className={styles["list_container"]}>
                  <div className={styles["c_list"]}>
                    <XtSvg src={photoSvg} style={{ height: "16px" }} />
                    <span className={styles["c_font"]}>{t("account.companyConfirm")}</span>
                  </div>
                  <div className={styles["c_list"]}>
                    <XtSvg src={authSvg} style={{ height: "16px" }} />
                    <span className={styles["c_font"]}>{t("account.AddFiatTradingPermission")}</span>
                  </div>
                  <div className={styles["c_list"]}>
                    <XtSvg src={timeSvg} style={{ height: "16px" }} />
                    <span className={styles["c_font"]}>{t("account.ReviewPeriodWithin2Days")}</span>
                  </div>
                </div>
                <div className={styles["fenge"]}>
                  {confirmResult.status == 0 && <div className={styles["dasheds"]}></div>}

                  {confirmResult.status == 2 && (
                    <div className={styles["again_confirm"]}>
                      <div className={styles["a_icon"]}>
                        <XtSvg src={unpassSvg} style={{ height: "16px", color: "rgba(185, 185, 186, 1)" }} />
                        <Tooltip placement="topRight" title={confirmResult.reason}>
                          <span>
                            {t("account.Whyreviewfailed")}：{confirmResult.reason}
                          </span>
                        </Tooltip>
                      </div>
                      <div className={styles["again_to"]} onClick={jumpconfirm}>
                        <span style={{ fontSize: "14px", fontWeight: "normal" }}>{t("account.Reverify")}</span>
                      </div>
                    </div>
                  )}
                  {confirmResult.status == -1 && (
                    <div className={styles["toconfirm"]} onClick={jumpconfirm}>
                      <span>{t("account.VerifyNow")}</span>
                    </div>
                  )}
                </div>
                <div className={styles["list_footer"]}>
                  <div className={styles["bicontent"]}>
                    <div className={styles["bi_list"]}>
                      <p className={styles["isicon"]}>
                        {confirmResult.status == 1 && (
                          <XtSvg src={require("@/assets/icon-svg/account/otc_attestation_success_ico.svg")} style={{ height: "16px" }} />
                        )}
                        <span className={styles["bi_name"]}>{t("account.Fiat")}</span>
                      </p>
                      <div className={styles["bi_mes"]}>
                        <div className={styles["cz"]}>
                          <span>{t("account.deposit")}</span>
                          <span className={styles["no_limit"]}>{t("account.NoLimit")}</span>
                        </div>
                        <div className={styles["tixian"]}>
                          <span>{t("account.withdraw")}:</span>
                          <span className={styles["no_limit"]}>{t("account.verificationWithdrawTip")}</span>
                        </div>
                      </div>
                    </div>
                    <div className={cx(styles["bi_list"], styles["mr2s"])}>
                      <p className={styles["isicon"]}>
                        {confirmResult.status == 1 && <XtSvg src={require("@/assets/icon-svg/account/otc_attestation_success_ico.svg")} />}
                        <span className={styles["bi_name"]}>{t("account.Cryptocurrency")}</span>
                      </p>
                      <div className={styles["bi_mes"]}>
                        <div className={styles["cz"]}>
                          <span>{t("account.deposit")}:</span>
                          <span className={styles["no_limit"]}>{t("account.NoLimit")}</span>
                        </div>
                        <div className={styles["tixian"]}>
                          <span>{t("account.withdraw")}</span>
                          <span className={styles["no_limit"]}>{t("account.verificationWithdrawTip")}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*当前您的限额*/}
          <Modal
            className={styles["auth-modal"]}
            open={showmodal}
            title={t("account.checkAuth")}
            onCancel={() => setShowmodal(false)}
            footer={null}
          >
            <p>{t("account.remainingAmount")}</p>
            {/* 法币交易 */}
            <div className={styles["role_bi_div"]}>
              <div className={styles["role_tit"]}>{t("account.Fiats")}</div>
              <div className={styles["role_con"]}>
                <div>{t("account.deposit")}：</div>
                <div className={store.user.userInfo?.authLevel == 0 ? styles["role_con_noTrading"] : ""}>
                  {store.user.userInfo?.authLevel == 0 ? t("account.NoTrading") : t("account.NoLimit")}
                </div>
              </div>
              <div className={styles["role_con"]}>
                <div>{t("account.withdraw")}：</div>
                <div className={styles[store.user.userInfo?.authLevel == 0 ? "role_con_noTrading" : ""]}>
                  {store.user.userInfo?.authLevel == 0
                    ? t("account.NoTrading")
                    : limitList.find((ii) => ii.grade == store.user.userInfo?.authLevel)?.limitAmount ||
                      limitList.find((ii) => ii.grade == store.user.userInfo?.authLevel)?.limitAmount == 0
                      ? limitList.find((ii) => ii.grade == store.user.userInfo?.authLevel)?.limitAmount + " USD/" + t("account.periodDay")
                      : t("account.NoLimit")}
                </div>
              </div>
            </div>

            {/* 加密货币 */}
            <div className={styles["role_bi_div"]}>
              <div className={styles["role_tit"]}>{t("account.Cryptocurrency")}</div>
              <div className={styles["role_con"]}>
                <div>{t("account.deposit")}：</div>
                <div>{t("account.NoLimit")}</div>
              </div>
              <div className={styles["role_con"]}>
                <div>{t("account.withdraw")}：</div>
                <div>
                  {withdrawLimitList.find((ii) => ii.grade == store.user.userInfo?.authLevel)?.limitAmount ||
                    withdrawLimitList.find((ii) => ii.grade == store.user.userInfo?.authLevel)?.limitAmount == 0
                    ? withdrawLimitList.find((ii) => ii.grade == store.user.userInfo?.authLevel)?.limitAmount + " USDT/" + t("account.periodDay")
                    : t("account.NoLimit")}
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </>
  );
};
export default observer(Company);
